/**
 * 登录中心全局配置文件，规范命名 by Robin
 * local: 本地环境
 * fat: 测试环境
 * uat: 预发环境
 * pro: 生产环境
 */
import { hashHistory, browserHistory } from 'dva/router'
import local from './local.json'
import fat from './fat.json'
import uat from './uat.json'
import pro from './pro.json'

const env = 'pro'
const history = hashHistory

let out = {}

switch (env) {
  case 'local':
    out = {history, ...local, env}
    break
  case 'fat':
    out = {history, ...fat, env}
    break
  case 'uat':
    out = {history, ...uat, env}
    break
  case 'pro':
    out = {history, ...pro, env}
    break
}

export default out



/** WEBPACK FOOTER **
 ** ./src/utils/config.js
 **/